export function isValidGuid(id: string): boolean {
    const guidRegex: RegExp = /^[0-9a-f]{8}\-[0-9a-f]{4}\-[0-9a-f]{4}\-[0-9a-f]{4}\-[0-9a-f]{12}$/;
    return guidRegex.test(id);
}
